var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", width: "24", height: "24", viewBox: "0 0 24 24" }, props),
    React.createElement("path", { fill: "#FFF", d: "M20 20.5a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-7.328a2.827 2.827 0 0 1-2.368-1.426 3.23 3.23 0 0 1 .927-4.231l7.697-5.498a3 3 0 0 1 3.488 0l7.697 5.498a3.23 3.23 0 0 1 .927 4.231A2.83 2.83 0 0 1 20 13.172V20.5zm-2-8.04L12.577 8.63a1 1 0 0 0-1.154 0L6 12.46V20.5h12v-8.04zM3.721 9.141a1.23 1.23 0 0 0-.31 1.679.832.832 0 0 0 1.159.2l5.7-4.024a3 3 0 0 1 3.46 0l5.7 4.024a.832.832 0 0 0 1.202-.267 1.23 1.23 0 0 0-.353-1.612L12.58 3.644a1 1 0 0 0-1.162 0L3.72 9.142zm5.986 5.65l1.333 1.334 3.796-3.373a1 1 0 1 1 1.328 1.494l-4.5 4a1 1 0 0 1-1.371-.04l-2-2a1 1 0 0 1 1.414-1.414z", fillRule: "evenodd" })
  );
});